/* eslint-disable react/prop-types */
import React from 'react';
const TableCell = ({ column, row }) => (React.createElement("td", { key: `cell-${column.accessor}` }, column.Cell ? column.Cell({ original: row }) : row[column.accessor]));
export { TableCell, };
